export const LOCAL_ACCESS_MANAGEMENT_PATH = '/accessManagement';

export const PATH_ACCESS_MANAGEMENT_ROLES_LIST_PATH = `${LOCAL_ACCESS_MANAGEMENT_PATH}/roles`;
export const PATH_ACCESS_MANAGEMENT_PERMISSIONS_LIST_PATH = `${LOCAL_ACCESS_MANAGEMENT_PATH}/permissions`;